import { useState } from 'react'
import type { NaicsSuggestion } from '@services/onboardingApi'
import './NaicsConfirmation.css'

interface NaicsConfirmationProps {
  suggestions: NaicsSuggestion[]
  loading: boolean
  onConfirm: (naicsCode: string) => void
  onSkip: () => void
}

function NaicsConfirmation({ suggestions, loading, onConfirm, onSkip }: NaicsConfirmationProps) {
  const [manualCode, setManualCode] = useState('')
  const [showManual, setShowManual] = useState(false)

  if (loading) {
    return (
      <div className="naics-confirmation">
        <div className="naics-loading">Classifying industry...</div>
      </div>
    )
  }

  if (suggestions.length === 0) {
    return (
      <div className="naics-confirmation">
        <p className="naics-empty">Could not determine industry classification.</p>
        <div className="naics-manual-entry">
          <input
            type="text"
            value={manualCode}
            onChange={(e) => setManualCode(e.target.value)}
            placeholder="Enter NAICS code (e.g., 621340)"
            pattern="\d{2,6}"
          />
          <button
            className="btn-primary btn-sm"
            onClick={() => manualCode.trim() && onConfirm(manualCode.trim())}
            disabled={!manualCode.trim()}
          >
            Use Code
          </button>
        </div>
        <button className="btn-link" onClick={onSkip}>Skip for now</button>
      </div>
    )
  }

  return (
    <div className="naics-confirmation">
      <p className="naics-prompt">Select your industry classification:</p>
      <div className="naics-suggestions">
        {suggestions.map((s) => (
          <button
            key={s.naics_code}
            className="naics-suggestion"
            onClick={() => onConfirm(s.naics_code)}
          >
            <span className="naics-code">{s.naics_code}</span>
            <span className="naics-label">{s.industry_label}</span>
            <span className="naics-specificity">{s.specificity}</span>
          </button>
        ))}
      </div>

      {!showManual ? (
        <button className="btn-link" onClick={() => setShowManual(true)}>
          Enter code manually
        </button>
      ) : (
        <div className="naics-manual-entry">
          <input
            type="text"
            value={manualCode}
            onChange={(e) => setManualCode(e.target.value)}
            placeholder="Enter NAICS code"
            pattern="\d{2,6}"
          />
          <button
            className="btn-primary btn-sm"
            onClick={() => manualCode.trim() && onConfirm(manualCode.trim())}
            disabled={!manualCode.trim()}
          >
            Use Code
          </button>
        </div>
      )}

      <button className="btn-link" onClick={onSkip}>Skip for now</button>
    </div>
  )
}

export default NaicsConfirmation
